// One rule for rendering a minutes-count on the day sheet: under an hour it
// stays minutes, from an hour up it reads in hours (+ leftover minutes).
//
// It lives here — not inline in AppointmentRow — because the mobile card
// renders the identical chips, and two copies of "when does انتظار switch to
// ساعت" is how the two surfaces would come to disagree. appointments.js itself
// stays text-free, so the key-choosing lives one file over.
//
// The three variants per base key ('', 'Hours', 'HoursMinutes') must exist in
// every catalogue; the parity test in tests/i18n.test.js is what enforces it.

export function durationLabel(t, baseKey, min) {
  if (min < 60) return t(baseKey, { count: min });
  const hours = Math.floor(min / 60);
  const minutes = min % 60;
  if (minutes === 0) return t(`${baseKey}Hours`, { hours });
  return t(`${baseKey}HoursMinutes`, { hours, minutes });
}
